import * as React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { groupPlanMap } from 'constants/plansales/billing';
import { GroupPlanType } from 'types/plansales/plan';
import { CheckObjectValue } from 'types/common';

interface Props {
  selectablePlanTypes?: GroupPlanType[];
  selectedPlanTypes: CheckObjectValue;
  onChangeSelectedGroupPlan: (
    status: GroupPlanType,
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const GroupPlanTypeFilter = ({
  selectablePlanTypes = [GroupPlanType.STANDARD, GroupPlanType.PREMIUM, GroupPlanType.ADVANCED],
  selectedPlanTypes,
  onChangeSelectedGroupPlan,
}: Props) => {
  return (
    <>
      {selectablePlanTypes.map(plan => (
        <FormControlLabel
          key={plan}
          control={
            <Checkbox
              value={plan}
              color={'primary'}
              checked={selectedPlanTypes[plan]}
              onChange={onChangeSelectedGroupPlan(plan)}
            />
          }
          label={groupPlanMap[plan]}
        />
      ))}
    </>
  );
};

export default GroupPlanTypeFilter;
